import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { getEfficiencyDataApiUrl } from '../../../constants/apiUrls'
import {
    fetchEfficiencyData,
    fetchEfficiencyDataAsync,
    setEfficiencyDataState,
} from '../../actions/app/efficiencyData.actions'
import { fetchVisualizationAsync } from '../../actions/app/visualization.actions'
import isMiwiEnabledSelector from '../../selectors/feature-scope/isMiwiEnabledSelector'
import { ApiRequest } from '../../apiRequest'
import is3DExhibitionEnabledSelector from '../../selectors/feature-scope/is3DExhibitionEnabledSelector'
import { createLatestRequestTracker } from './helpers/latestRequestTracker'

// eslint-disable-next-line max-len
const efficiencyDataMiddleware = (apiRequest: ApiRequest): Middleware => (store) => {
    const latestRequest = createLatestRequestTracker()

    return (next) => (action) => {
        next(action)
        const { dispatch, getState } = store

        if (isActionOf(fetchVisualizationAsync.request, action)) {
            const shouldFetchEfficiencyData = isMiwiEnabledSelector(getState()) || is3DExhibitionEnabledSelector(getState())

            if (shouldFetchEfficiencyData) {
                dispatch(fetchEfficiencyData())
            }
        }

        if (isActionOf(fetchEfficiencyData, action)) {
            latestRequest.markIssued(action)
            apiRequest({
                options: {
                    url: getEfficiencyDataApiUrl(),
                    method: 'GET',
                },
                asyncActions: fetchEfficiencyDataAsync,
                causedBy: action,
            }, dispatch)
        }

        if (isActionOf(fetchEfficiencyDataAsync.success, action)) {
            if (!latestRequest.isLatest(action)) {
                return
            }
            const efficiencyData = action.payload

            dispatch(setEfficiencyDataState(efficiencyData))
        }
    }
}

export default efficiencyDataMiddleware
